// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"566":"lang/en-json","947":"lang/en-US-json"}[chunkId] + "-" + {"566":"6e0deda1c8f2262b1c01","947":"b8636679f701798a5186"}[chunkId] + ".js";
};